import { Outlet, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { adminStatistics } from "../../entities/admin/api/adminApi";
import { useEffect } from "react";
import { AdminStatisticsContext } from "@entities/admin/model/AdminContext";

export default function AdminRoute() {
  const navigate = useNavigate();
  const hasToken = Boolean(localStorage.getItem("access_token"));

  const { data, isLoading, isFetching, isError, isSuccess, refetch } = useQuery({
    queryKey: ["adminStatistics"],
    queryFn: adminStatistics,
    staleTime: 5 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
    refetchInterval: false,
    retry: false,
    enabled: hasToken,
  });

  useEffect(() => {
    if (!hasToken || isError) {
      navigate("/auth/login", { replace: true });
    }
  }, [hasToken, isError, navigate]);

  if (!hasToken || isLoading || isError) return null;

  return isSuccess ? (
    <AdminStatisticsContext.Provider
      value={{ adminStatistics: data.data, isLoading, isFetching, refetch }}
    >
      <Outlet />
    </AdminStatisticsContext.Provider>
  ) : null;
}
